export const HBCOAL_SALE_PLAN_PAGE_UUID = 'cb261610-6393-4fae-8d5f-c4f7a612aa83'
